// @flow

import fetchForUser from '../utils/fetchForUser';
import type User from '../models/User';
import { isLocal, mockAll } from './utils';

const mock = false;
const getUrl = (): string =>
  (mock || mockAll) && isLocal
    ? `/mock/preismodell/couponCode.json`
    : `/api/package/vip/cabinOption/couponCode`;

export default {
  get: (user: User) => fetchForUser(user, getUrl()),
};

export type ApiResponse = {
  headline: ?string,
  text: ?string,
  code: ?string,
};

export type ApiType = {
  get: User => Promise<ApiResponse>,
};
